import { Component, OnInit } from '@angular/core';
import { RolesPermisosService } from './roles-y-permisos.service';
import { CONSTANTS } from 'app/core/constants';
import { Tipologia } from 'app/models/tipologias.model';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ArrowBackComponent } from 'app/modules/GlobalComponents/arrow-back.component';
import { MatIconModule } from '@angular/material/icon';
import { UserAvatarWidgetComponent } from 'app/modules/GlobalComponents/user-avatar-component';
import { MatMenuModule } from '@angular/material/menu';
import { ActualizarPermisosComponent } from './actualizar-permisos/actualizar-permisos.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FormRolComponent } from './form-agregar-rol/form-agregar-rol.component';
import { UtilsService } from 'app/modules/utils-service';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'administrar-roles-y-permisos',
    templateUrl: 'roles-y-permisos.component.html',
    imports:[
        CommonModule,
        MatButtonModule,
        MatMenuModule,

        ArrowBackComponent,
        MatIconModule,
        UserAvatarWidgetComponent,
        HasPermissionsDirective,
    ]
})

export class RolesPermisosComponent implements OnInit {
    TIPOLOGIA_ID_PADRE_ROLES= CONSTANTS.TIPOLOGIA_ID_PADRE_ROLES
    roles: Tipologia[]

    idRolAdministrador:number = CONSTANTS.ID_ROL_ADMINISTRADOR
    idRolTecnico:number = CONSTANTS.ID_ROL_TECNICO

    constructor(
        private rolesPermisosService:RolesPermisosService,
        private UtilsService: UtilsService,
        public dialog: MatDialog,
        private router: Router
    ) { 
        this.getRoles()
    }

    ngOnInit() { }

    getRoles(){
        this.rolesPermisosService.getColeccionistas(this.TIPOLOGIA_ID_PADRE_ROLES)
        .then((response:Tipologia[])=>{
            this.roles= response
        })
    }
    
    agregarRol(){
         const dialog = this.dialog.open(FormRolComponent, {
                            panelClass: ['w-full', 'md:w-4/12','mx-0'],
                            maxHeight: 'calc(100vh - 4rem)',
                            disableClose: true,
                        })
    }

    actualizarPermisos(rol:Tipologia){
        this.router.navigateByUrl(`/roles-y-permisos/rol/${rol.tipologiaId}`)
    }

    eliminarRol(rol:Tipologia){
        this.UtilsService.open_confirm_dialog(`Esta seguro que desea eliminar el rol ${rol.descripcion}`, 'Eliminar Rol de Usuario')
        .subscribe(response => {
            if (response === 'confirmed') {
                    this.rolesPermisosService.eliminarRol(rol.tipologiaId)
                    .then((response:any)=>{
                        this.UtilsService.openSuccessSnakBar(response.message)
                        this.getRoles()
                    })
            }
        })
    }
    
}